<template>
	<div class="personSet_page">
		<div class="message_content">
			<div v-if="message_detail.length>0" class="message_content_main" v-html="message_detail"></div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'message_detail',
	  data () {
	    return {
			message_detail:"<p>Enter coupon code REFRESH. Limit one (1) free Resist Anti-Aging Eye Gel travel size and one (1) free bag per order of $50+, while supplies last. Free item(s) will be automatically added at cart when threshold has been met, after any discounts are applied. Taxes, fees and shipping costs do not count toward purchase amount threshold. Offer cannot be applied to previous purchases, auto-replenishment orders or be combined with other discounts or offers. Applies to in-stock items only; no rain checks. Free gift with purchase item(s) may not be returned or exchanged. Paula’s Choice reserves the right to change or replace the free item offered at any time. Offer expires 11:59 pm PT, April 4, 2019.</p><p>Free Standard Shipping on $50+ No cash value. Free shipping will be applied at checkout when threshold is met, after all discounts have been applied. Applies to US and Canada only.</p><p>100% MONEY BACK GUARANTEEWe believe products should work. If you aren't completely satisfied with your purchase, we'll give you a full refund or credit for products returned within 60 days. Guaranteed.If you are having trouble reading this email, you may view the online version </p><p>© 2019 Paula's Choice. All rights reserved.Paula's Choice and Cosmetics Cop are registered trademarks of Paula's Choice, LLC.</p>",
	    }
	  }
	}
</script>

<style scoped="scoped">
	.message_content{
		width:600px;
		margin-left:100px;
		background-color: rgba(45,47,58,0.5);
		padding:0 30px 30px 30px;
		border-radius: 20px;
	}
	.message_content_main{
		padding:30px;
		font-size:14px;
		color:#fff;
	}
	.message_content_main p{
		line-height: 18px;
		margin-top:20px;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/personSet/message_detail.vue